import React from "react";
import useIsMobile from "../../hooks/useIsMobile";

const s = {
  card: {
    background: "var(--dashboard-card-bg)", borderRadius: "var(--dashboard-card-radius)", padding: "24px 28px",
    boxShadow: "var(--dashboard-card-shadow)", marginBottom: 24,
    border: "var(--dashboard-card-border)",
  },
  header: { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 0, flexWrap: "wrap", gap: 12 },
  titleGroup: { display: "flex", alignItems: "baseline", flexWrap: "wrap", gap: "10px 14px" },
  vehicleTitle: {
    fontFamily: "var(--font-heading)",
    fontSize: "var(--dashboard-vehicle-title-size)",
    fontWeight: "var(--dashboard-title-weight)",
    color: "var(--text-primary)",
    margin: 0,
  },
  settingsButton: {
    border: "1.5px solid var(--border)",
    borderRadius: "var(--dashboard-control-radius)",
    background: "var(--dashboard-selector-bg)",
    color: "var(--text-primary)",
    padding: "7px 11px",
    fontSize: 12,
    fontWeight: 800,
    cursor: "pointer",
  },
  grid: { display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "var(--dashboard-grid-gap)" },
  field: {},
  fieldLabel: { fontSize: "var(--dashboard-field-label-size)", fontWeight: 700, color: "var(--text-faint)", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: 2 },
  fieldValue: { fontSize: "var(--dashboard-field-value-size)", fontWeight: 500, color: "var(--text-primary)" },
  detailsButton: {
    border: "none",
    background: "transparent",
    color: "var(--teal-dark)",
    padding: 0,
    fontSize: 12,
    fontWeight: 900,
    cursor: "pointer",
    whiteSpace: "nowrap",
  },
};

function formatVal(val) {
  if (val === null || val === undefined || val === "" || val === "NaN") return "—";
  return String(val);
}

function vehicleLabel(sample) {
  const parts = [sample.vehicle_year, sample.vehicle_make, sample.vehicle_model].filter(Boolean);
  return parts.length > 0 ? parts.join(" ") : "Unknown Vehicle";
}

function formatDate(dateStr) {
  if (!dateStr) return "—";
  try {
    return new Date(dateStr).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });
  } catch { return dateStr; }
}

function formatApp(val) {
  if (!val) return "—";
  return val.replace(/_/g, " ").replace(/\b\w/g, c => c.toUpperCase());
}

export default function SampleSummary({ sample, onOpenSettings, detailsExpanded = false, onDetailsExpandedChange }) {
  const isMobile = useIsMobile();
  if (!sample) return null;

  const fields = [
    { label: "Vehicle Name", value: sample.vehicle_name },
    { label: "VIN", value: sample.vehicle_vin },
    { label: "Application", value: formatApp(sample.vehicle_application) },
    { label: "Engine Type", value: formatApp(sample.vehicle_engine_type) },
    { label: "Fuel Type", value: sample.vehicle_fuel_type },
    { label: "Component", value: sample.component_type },
    { label: "Engine Miles", value: formatVal(sample.engine_miles) },
    { label: "Engine Hours", value: formatVal(sample.engine_hours) },
    { label: "Sample Miles", value: formatVal(sample.sample_miles) },
    { label: "Sample Hours", value: formatVal(sample.sample_hours) },
    { label: "Oil", value: [sample.oil_brand, sample.oil_viscosity].filter(Boolean).join(" ") || "—" },
    { label: "From Oil Change", value: sample.is_from_oil_change === "True" || sample.is_from_oil_change === true ? "Yes" : sample.is_from_oil_change === "False" || sample.is_from_oil_change === false ? "No" : "—" },
    { label: "Used Additives", value: sample.used_additives === "True" || sample.used_additives === true ? "Yes" : sample.used_additives === "False" || sample.used_additives === false ? "No" : "—" },
    { label: "Brand New Oil", value: sample.is_brand_new_oil === "True" || sample.is_brand_new_oil === true ? "Yes" : sample.is_brand_new_oil === "False" || sample.is_brand_new_oil === false ? "No" : "—" },
    { label: "Date Tested", value: formatDate(sample.sample_tested_date) },
  ];

  return (
    <div style={{ ...s.card, padding: isMobile ? "16px 16px" : "24px 28px" }} className="animate-fade-in">
      <div style={s.header}>
        <div style={s.titleGroup}>
          <h2 style={{ ...s.vehicleTitle, fontSize: isMobile ? 18 : "var(--dashboard-vehicle-title-size)" }}>{vehicleLabel(sample)}</h2>
          <button type="button" style={s.detailsButton} onClick={() => onDetailsExpandedChange?.(!detailsExpanded)}>
            {detailsExpanded ? "Close details" : "More details"}
          </button>
        </div>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {onOpenSettings && (
            <button type="button" style={s.settingsButton} onClick={onOpenSettings}>
              Vehicle/Report Settings
            </button>
          )}
        </div>
      </div>
      {detailsExpanded && (
        <div style={{ ...s.grid, marginTop: 20, gridTemplateColumns: `repeat(auto-fill, minmax(${isMobile ? 140 : 200}px, 1fr))` }}>
          {fields.map(f => (
            <div key={f.label} style={s.field}>
              <div style={s.fieldLabel}>{f.label}</div>
              <div style={s.fieldValue}>{formatVal(f.value)}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
